// extracted by mini-css-extract-plugin
export default {"wishlist_badge":"whishlistbadge_wishlist_badge__A0O3j","wishlist_icon":"whishlistbadge_wishlist_icon__iFjkW","wishlist_number":"whishlistbadge_wishlist_number__9QPyI"};